<script setup lang="ts">
import { provide, ref, onMounted, onBeforeUnmount, computed } from 'vue'
import BaseChart from '@/charts/BaseChart.vue'

const props = defineProps<{
	  data?: { date: string; count: number }[]
}>()

const chartOptions = computed(() => ({
	  tooltip: {
		      trigger: 'axis',
		      axisPointer: {
			            type: 'shadow'
			          }
		    },
	  grid: {
		      left: '3%',
		      right: '4%',
		      bottom: '3%',
		      containLabel: true
		    },
	  xAxis: {
		      type: 'category',
		      data: props.data?.map(item => item.date) || [],
		      axisLabel: {
			            rotate: 45
			          }
		    },
	  yAxis: {
		      type: 'value',
		      name: 'New Users'
		    },
	  series: [
		      {
			            name: 'New Users',
			            type: 'line',
			            smooth: true,
			            data: props.data?.map(item => item.count) || [],
			            areaStyle: {
					            color: {
							              type: 'linear',
							              x: 0,
							              y: 0,
							              x2: 0,
							              y2: 1,
							              colorStops: [{
									                  offset: 0,
									                  color: 'rgba(59, 130, 246, 0.5)'
									                }, {
												            offset: 1,
												            color: 'rgba(59, 130, 246, 0.1)'
												          }]
							            }
					          },
			            itemStyle: {
					            color: '#3b82f6'
					          }
			          }
		    ]
}))
</script>

<template>
	  <BaseChart :options="chartOptions" class="h-full w-full" />
</template>
